// เมนูซ้ายของหน้า Setting
import type { MenuIconName } from "@shared/ui/menu-icons";

export type SettingMenu = { id: string; label: string; icon: MenuIconName };

export const SETTING_MENUS: SettingMenu[] = [
  { id: "product", label: "Product", icon: "box" },
  { id: "group", label: "Product Group", icon: "layers" },
  { id: "staff", label: "Staff", icon: "users" },
  { id: "globalmenu", label: "Global Menu", icon: "grid" },
  { id: "projectcode", label: "Project Code", icon: "folder" },
  { id: "financedoc", label: "Finance Document", icon: "wallet" },
];

/** เมนูที่ดึงเนื้อหาจาก Inbox Center มาแสดง — เปิด/ปิดได้ต่อแบรนด์/กลุ่ม */
export const BRAND_FEATURES = [
  { key: "inbox", label: "Inbox", icon: "chat", target: "เมนู Messages" },
  { key: "content", label: "Content Calendar", icon: "layout", target: "เมนู Content › Calendar" },
  { key: "report", label: "Report", icon: "trend", target: "เมนู Analytics › Facebook Inbox" },
] as const;

// สีที่สุ่มให้แบรนด์ตอน enable (ใช้เมื่อโลโก้โหลดไม่ได้)
const BRAND_PALETTE = [
  "#7b5cf0",
  "#e0559a",
  "#f59e0b",
  "#0866ff",
  "#16a34a",
  "#0d9488",
  "#dc2626",
  "#7c3aed",
];

export function pickColor(code: string): string {
  let s = 0;
  for (const ch of String(code)) s += ch.charCodeAt(0);
  return BRAND_PALETTE[s % BRAND_PALETTE.length];
}

export const groupTagline = (g: { members: string[] }) =>
  `กลุ่มสินค้า · ${g.members.length} สินค้า`;

export const settingPath = (menu: string) => `/setting/${menu}`;
